
import React, { useState } from 'react';
import '../blogs.module.css'
import CommentOverflow from './CommentOverflow';
import moment from 'moment';
import { isAdmin } from '../../../utils/localStorage';


const ReplyComment = ({reply, refetch}) => {

    const [overflow,setOverflow] = useState(false);

    const toggleOverflow = () => {setOverflow(!overflow)}

    const OverflowButton = () => {
        if (isAdmin()){
            return <div className='overflowButton' onClick={toggleOverflow}>⋮</div>
        }
        else return null
    }

    return (
        <div className='replyComment'>
            <div className='commentInfo'>
                <img className='commentImage' src={'https://cdn-images-1.medium.com/fit/c/150/150/1*PhVZXKzCrkmS9ADYRi23Yg.png'}/>
                <div className='commentNameDate'>
                    <div className='commentName'> {reply.commentedBy} </div>
                    <div className='commentDate'> {moment(reply.commentedAt).fromNow()}</div>
                </div>
            <OverflowButton/>
            </div>
            {overflow?<CommentOverflow comment={reply} refetch={refetch}/>:""}
            <div className='commentContent'>
                {reply.body}
            </div>
        </div>
    )
}

export default ReplyComment;


// WEBPACK FOOTER //
// ./src/components/Blogs/Comments/ReplyComment.js